import React, { useMemo } from 'react'

import { useLoading, useServerError } from 'shared/hooks'
import { useChartSources } from '../serviceHooks/useChartSources'
import { LoadMore, NoItems } from 'components'
import { ChartSourcesTable } from 'modules/ChartSources/components'
import { ChartSourcesTableData } from '../components/ChartSourcesTable/ChartSourcesTable.props'
import { Spinner } from 'components/Spinner/Spinner'

export const ChartSourcesContainer = () => {
  const { chartSources, chartSourcesLoading, chartSourcesError, total, loadMoreChartSources, refetch } =
    useChartSources()

  useServerError([chartSourcesError])
  useLoading({ isLoading: chartSourcesLoading })

  const chartSourceList: ChartSourcesTableData[] = useMemo(
    () =>
      chartSources?.map((chs, index) => {
        return {
          id: index, // We are adding unique id for future usage because this dataset does not have unique property
          chart: chs?.chart ?? '',
          chart_id: chs?.chart_id ?? '',
          configuration: chs?.configuration ?? '',
          country_code: chs?.country_code ?? '',
          cycle: chs?.country_code ?? '',
          release_info: chs?.release_info ?? '',
          import_limit: chs?.import_limit ?? 0
        }
      }),
    [chartSources]
  )

  return chartSourcesLoading ? (
    <Spinner />
  ) : chartSources?.length ? (
    <>
      <ChartSourcesTable chartSourcesList={chartSourceList ?? []} refetch={refetch} />
      <LoadMore
        label="chart sources on Storybox"
        onLoad={loadMoreChartSources}
        isItemsLoading={chartSourcesLoading}
        itemsTotal={total}
        itemsCount={chartSources.length}
      />
    </>
  ) : (
    <NoItems name="Chart Sources" />
  )
}
